import { takeUntil } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/components/base/base.component';
import { Teacher } from 'src/app/core/models/teacher';
import { AlertService } from 'src/app/core/services/alert.service';
import { BaseService } from 'src/app/core/services/base.service';

@Component({
  selector: 'app-teacher-dashboard',
  templateUrl: './teacher-dashboard.component.html',
  styleUrls: ['./teacher-dashboard.component.scss']
})
export class TeacherDashboardComponent extends BaseComponent implements OnInit {

  userFullName: string;
  teacherId: number;

  tokenValid: boolean;

  teacher = {} as Teacher;

  constructor(
    public baseService:BaseService,
    private alertService: AlertService,
    private route :ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
  ) { super() }

  ngOnInit(): void {
    this.userFullName = localStorage.getItem('userFullName');

    var teachId = localStorage.getItem('teacherId');
    this.teacherId = Number(teachId);

    const token = localStorage.getItem('token');
    const isTeacher = localStorage.getItem('isTeacher');
    if (token && isTeacher) { this.tokenValid = true; }
    else { this.tokenValid = false; }

    this.loadData();
  }

  loadData(){
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      data=>{
        this.teacher = data.teacher.result.returnData;
        // console.log(this.teacher)
      });
  }

  // viewDashnoard(id) {
  //   this.router.navigate(['/teacher-dashboard/edit', this.teacherId]);
  // }

  viewProfile(id) {
    this.router.navigate(['/teacher-profile/edit', this.teacherId]);
  }

  viewCourses(id) {
    this.router.navigate(['/teacher-courses/edit', this.teacherId]);
  }

  viewSettings(id) {
    this.router.navigate(['/teacher-settings/edit', this.teacherId]);
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('academyToken');
    localStorage.removeItem('studentId');
    localStorage.removeItem('profileImg');
    localStorage.removeItem('userId');
    localStorage.removeItem('isTeacher');
    localStorage.removeItem('teacherId');
    localStorage.removeItem('userFullName');
    localStorage.removeItem('token');
    this.router.navigate(['/home']);

    setTimeout(() => {
      this.router.navigate(['/home']);
    }, 200);
    if (!localStorage.getItem('up')) {
      localStorage.setItem('up', 'no reload');
      location.reload();
    } else {
      localStorage.removeItem('up');
    }
  }

}
